/**
 * Created by Andrey Popov on 12/30/25.
 */

const FixCustomerView = cc.Scale9Sprite.extend({
    ctor: function (customer) {
        const background = bundles.extended_customer_view.frames.ready_customer_view_bg;
        this._super(background, cleverapps.UI.getScale9Rect(background, cleverapps.UI.Scale9Rect.TwoPixelXY));

        const styles = cleverapps.styles.FixCustomerView;

        this.setContentSize2(styles);

        const pointer = new cc.Sprite(bundles.extended_customer_view.frames.ready_customer_view_tail);
        pointer.setAlignment(styles.pointer);
        this.addChild(pointer);

        const unit = customer.unit;
        const icon = UnitView.getUnitImage({ code: unit.code, stage: unit.stage + 1 }, { preferStatic: true, useLibraryAnchors: true });
        cleverapps.UI.fitToBox(icon, styles.icon);
        icon.setAlignment(styles.icon);
        this.addChild(icon);

        const button = new cleverapps.UI.Button({
            text: Messages.get("Customer.Fix"),
            textVariant: "tiny",
            width: cleverapps.styles.FixCustomerView.button.width,
            height: cleverapps.styles.FixCustomerView.button.height,
            type: cleverapps.styles.UI.Button.Images.small_button_green,
            onClicked: () => {
                customer.exchange();
            }

        });
        button.adviceTarget = Map2d.SPAWN;
        button.setAlignment(styles.button);
        this.addChild(button);
    }
});

cleverapps.styles.FixCustomerView = {
    width: 170,
    height: 210,

    pointer: {
        x: { align: "center" },
        y: -2
    },

    icon: {
        x: { align: "center" },
        y: { align: "center", dy: 34 },

        width: 140,
        height: 140
    },

    button: {
        width: 140,
        height: 50,

        x: { align: "center" },
        y: { align: "bottom", dy: 12 }
    }
};